import tvtApi from '../services/tvt-api';

export const ACTOR_REQUEST = 'ACTOR_REQUEST';
export const ACTOR_SUCCESS = 'ACTOR_SUCCESS';
export const ACTOR_ERROR = 'ACTOR_ERROR';
export const ACTOR_FILTER_UPDATED = 'ACTOR_FILTER_UPDATED';
export const ACTOR_FILTER_CLEARED = 'ACTOR_FILTER_CLEARED';

const requestActor = actorId => ({
  actorId,
  type: ACTOR_REQUEST
});

export const loadActor = fetchedActor => ({
  type: ACTOR_SUCCESS,
  fetchedActor
});

const errorActor = error => ({
  error,
  type: ACTOR_ERROR
});

export const updateShowFilters = filters => ({
  type: ACTOR_FILTER_UPDATED,
  filters
});

export const getActorData = actorId => async dispatch => {
  dispatch(requestActor(actorId));

  try {
    const actorData = await tvtApi.getActorData(actorId);
    dispatch(loadActor(actorData));
  } catch (error) {
    dispatch(errorActor(error));
  }
};
